"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindDelayedHover = bindDelayedHover;
var _react = require("react");
var _hooks = require("material-ui-popup-state/hooks");
var _excluded = ["onTouchStart", "onMouseOver", "onMouseLeave"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// https://github.com/jcoreio/material-ui-popup-state/issues/85#issuecomment-1509099257
function bindDelayedHover(popupState) {
  var delayMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var _bindHover = (0, _hooks.bindHover)(popupState),
    onTouchStart = _bindHover.onTouchStart,
    onMouseOver = _bindHover.onMouseOver,
    onMouseLeave = _bindHover.onMouseLeave,
    hoverAriaProps = _objectWithoutProperties(_bindHover, _excluded);
  var timeout = (0, _react.useRef)(null);
  var delayedMouseOver = (0, _react.useCallback)(function (e) {
    if (timeout.current) clearTimeout(timeout.current);

    // material-ui-popup-state's event handler uses currentTarget to set the anchorEl, but
    // currentTarget is only defined while the initial event is firing. Save the original
    // and set it again before calling the delayed event handler
    var currentTarget = e.currentTarget;
    timeout.current = setTimeout(function () {
      e.currentTarget = currentTarget;
      onMouseOver(e);
    }, delayMs);
  }, [onMouseOver]);
  var handleMouseLeave = (0, _react.useCallback)(function (e) {
    if (timeout.current) clearTimeout(timeout.current);
    onMouseLeave(e);
  }, [onMouseLeave]);
  return _objectSpread({
    onTouchStart: onTouchStart,
    onMouseOver: delayedMouseOver,
    onMouseLeave: handleMouseLeave
  }, hoverAriaProps);
}